
/// <amd-module name="Core/Medius.Core.Web/Scripts/components/readonlyTabs/readonlyDocumentDetails"/>
import * as ko from 'knockout';
import { ReadonlyDocumentDetailsComponent } from './readonlyDocumentDetailsComponent';
import { ReasonCodes } from '../invoice/reasonCodes/viewModel';

export default class ReadonlyDocumentDetails {
    public documentDataSection: any;
    public invoiceRemarkSection: any;
    public addressInformationSection: any;
    public reasonCodes: ReasonCodes;
    public taskData: any;

    constructor(taskData?: any) {
        this.taskData = taskData;

        this.documentDataSection = ko.pureComputed(() => ({
            functionComponent: ReadonlyDocumentDetailsComponent,
            props: {
                documentId: this.taskData?.Id() ? this.taskData.Id().toString() : '0',
            },
        }));
    }
}
